export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11401.80d1257b.jpg";